import i18next from 'i18next';

i18next.getLanguage = function () {
    return i18next.language.split("-")[0];
}

i18next.getLocal = function () {
    return i18next.language.split("-")[1];
}

i18next.getCurrency = function () {
    const lang = i18next.language.split("-")[0]
    if (lang === 'ko') {
        return 'KRW'
    } else if (lang === 'ja') {
        return 'JPY'
    } else {
        return 'USD'
    }
}

i18next.getCountryCode3 = function () {
    const lang = i18next.language.split("-")[0]
    if (lang === 'ko') {
        return 'kr'
    } else if (lang === 'ja') {
        return 'jp'
    } else {
        return 'us'
    }
}

i18next.init({
    lng: navigator.language || navigator.userLanguage,
    // lng: 'ja-KR',
    fallbackLng: 'en',
    debug: true,
    resources: {
        en: {
            translation: {
                ohlc: {
                    d: " Date: ",
                    o: " O: ",
                    h: " H: ",
                    l: " L: ",
                    c: " C: ",
                    v: " Vol: ",
                },
                desc: 'Try Traders.',
                desc2: 'You can download on iOS, Android.',
                buy: 'BUY',
                short: 'SHORT',
                move: 'MOVE',
                fast: 'FAST',
                sell: 'SELL',
                corver: 'EXIT',
                stop: 'STOP',
                country: "usa",
                remain: 'REMAIN : {{remain}}',
                result: {
                    exchange: 'EXCHANGE',
                    country: 'COUNTRY',
                    section: 'SECTOR',
                    industry: 'INDUSTRY',
                    title: 'RESULT',
                    investmentPeriod: 'PERIOD',
                    investment: 'Investment',
                    valuation: 'Valuation',
                    profit: 'Profit',
                    yield: 'Yield',
                    numberOfTransaction: 'Number of transaction',
                    result: 'RESULT',
                    transactionHistory: 'TRANSACTION HISTORY',
                    startAssets: 'Start net worth',
                    endAssets: 'End net worth',
                    bank: 'Bank',
                    stock: 'Stock',
                    total: 'Net worth',
                    useItem: 'ITEMS',
                    endMsg: 'Investment has finished.',
                    more2Years: '- More investment -',
                    moreInfo: 'Get more info',
                    showResult: 'Show result',
                    showDetail: 'DETAIL',
                    showChart: 'CHART',
                    investmentValue: 'Investment : {{value}}',
                    valuationValue: 'Valuation : {{value}}',
                    insuranceValue: 'Insurance fee : {{value}}',
                    insurance: 'INSURANCE',
                    dealInfo: '{{price}} * {{shareCount}}',
                },
                dealPopup: {
                    shareCount: '{{dealType}} {{shareCount}} shares.',
                    buy: 'Buy',
                    short: 'Short',
                },

                currency: {
                    usd: '$',
                    krw: '₩',
                    jpy: '¥',
                },

                language: {
                    kor: 'Korean',
                    usa: 'English',
                    jpn: 'Japanese',
                }
            },

        },

        ko: {
            translation: {
                ohlc: {
                    d: " 날짜: ",
                    o: " 시가: ",
                    h: " 고가: ",
                    l: " 저가: ",
                    c: " 종가: ",
                    v: " 거래량: ",
                },
                desc: 'Traders를 체험 해 보세요.',
                desc2: 'iOS, Android에서 다운로드 할 수 있습니다.',
                buy: '매수',
                short: '공매도',
                move: '이동',
                fast: '빠르게',
                sell: '매도',
                corver: '상환',
                stop: '정지',
                country: "kor",
                remain: '남은시간 : {{remain}}',
                result: {
                    exchange: '거래소',
                    country: '국가',
                    section: '구분',
                    industry: '산업',
                    title: '투자결과',
                    investmentPeriod: '투자기간',
                    investment: '투자금',
                    valuation: '평가액',
                    profit: '수익',
                    yield: '수익률',
                    numberOfTransaction: '거래 횟수',
                    result: '결과',
                    transactionHistory: '거래 내역',
                    startAssets: '기초 자산',
                    endAssets: '기말 자산',
                    bank: '은행계좌',
                    stock: '주식계좌',
                    total: '자산',
                    useItem: '아이템 사용',
                    endMsg: '투자가 종료 되었습니다.',
                    more2Years: '- 투자 기간 연장 -',
                    moreInfo: '...더 많은 정보',
                    showResult: '결과확인',
                    showDetail: '상세보기',
                    showChart: '차트보기',
                    investmentValue: '투자금 : {{value}}',
                    valuationValue: '평가액 : {{value}}',
                    insuranceValue: '보험금 : {{value}}',
                    insurance: '보험',
                },
                dealPopup: {
                    shareCount: '{{shareCount}} 주를 {{dealType}} 합니다.',
                    buy: '매수',
                    short: '공매도',
                },

                language: {
                    kor: '한국어',
                    usa: '영어',
                    jpn: '일본어',
                }
            }
        },

        ja: {

            translation: {
                ohlc: {
                    d: " 日付: ",
                    o: " 始値: ",
                    h: " 高値: ",
                    l: " 安値: ",
                    c: " 終値: ",
                    v: " 出来高: ",
                },
                desc: 'Tradersを体験してみてください。',
                desc2: 'iOS、Android、からダウンロードすることができます。',
                buy: '買取',
                short: '空売り',
                move: '進行',
                fast: '高速',
                sell: '賣渡',
                corver: '償還',
                stop: 'やめる',
                country: "jpn",
                remain: '残り時間 : {{remain}}',
                result: {
                    exchange: '取引所',
                    country: '国',
                    section: 'セクター',
                    industry: '産業',
                    title: '投資結果',
                    investmentPeriod: '投資期間',
                    investment: '投資金額',
                    valuation: '評価額',
                    profit: '収益',
                    yield: '収益率',
                    numberOfTransaction: '取引回数',
                    result: '結果',
                    transactionHistory: '取引内容',
                    startAssets: '期首資産',
                    endAssets: '期末資産',
                    bank: '銀行口座',
                    stock: '証券口座',
                    total: '資産',
                    useItem: 'アイテムの使用',
                    // endMsg: '투자가 종료 되었습니다.',
                    more2Years: '- 投資期間延長 -',
                    moreInfo: '...詳しくは',
                    showResult: '結果確認',
                    showDetail: '細部',
                    showChart: 'チャート',
                    investmentValue: '投資額 : {{value}}',
                    valuationValue: '評価額 : {{value}}',
                    insuranceValue: '保険金 : {{value}}',
                    insurance: '保険',
                },

                dealPopup: {
                    buy: '買取',
                    short: '空売り',
                },

                language: {
                    kor: '朝鮮語',
                    usa: '英語',
                    jpn: '日本語',
                }
            }
        }
    }
});

export default i18next;